import MockAdapter from 'axios-mock-adapter';
import axios from './axios';
import config from '../config/config';

import en from './mock/en/index';
import zh from './mock/zh/index';



const i18mock = config.locale === 'en' ? en : zh;


const mock = new MockAdapter(axios);
export const addGetAdapter = function (url, func) {
    mock.onGet(url).reply(() => [200, func()]);
};
export const addPostAdapter = function (url, func) {
    mock.onPost(url).reply(req => [200, func(req)]);
}
const random = function (min, max) {
    if (max === undefined) {
        max = min;
        min = 0;
    }
    let range = max - min;
    return Math.floor(Math.random() * range + min);
}


addGetAdapter('/getParkOverviewInfo', () => {
    return i18mock.getParkOverviewInfo;
});

addGetAdapter('/getParkPlanningInfo', () => {
    return i18mock.getParkPlanningInfo;
});
addGetAdapter('/getParkInvestmentInfo', () => {
    return i18mock.getParkInvestmentInfo;
});
addGetAdapter('/getParkOperationInfo', () => {
    return i18mock.getParkOperationInfo;
});
addGetAdapter('/getParkBuildingInfo', () => {
    return i18mock.getParkBuildingInfo;
});
addGetAdapter('/getProjectData', () => {
    return i18mock.getProjectData;
});
addGetAdapter('/getBuildingData', () => {
    return i18mock.getBuildingData;
});
addGetAdapter('/getParkingData', () => {
    return i18mock.getParkingData;
});
addGetAdapter('/getAdData', () => {
    return i18mock.getAdData;
});
addGetAdapter('/getOrganizationData', () => {
    return i18mock.getOrganizationData;
});
addGetAdapter('/getParkConstructionInfo', () => {
    return i18mock.getOrganizationData;
});

// 以下是模拟两个接口的示例
// addGetAdapter('/tempData', () => {
//     let now = Date.now();
//     let data = [];
//     for (let i = 0; i < 30; i++) {
//         data.unshift({
//             time: formatDate(new Date(now), 'HH:mm'),
//             value: random(700, 1000) / 10//Math.floor(Math.random() * 300 + 700) / 10,
//         })
//         now -= 1000 * 60;
//     }
//     return {
//         data
//     };
// });

// addGetAdapter('/faultList', () => {
//     return {
//         data: [
//         random(3),
//         random(10),
//         random(20)
//     ]};
// });


